import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ButtonBlue from '../../Buttons/ButtonBlue';
import ImageGallery from '../../Photography/ImageGallery';
import Modal from '../../Photography/Modal';
import config from '../../../config';
import './home-page-photography.css';

const HomePagePhotography = () => {
  const [photos, setPhotos] = useState([]);
  const [modalPhoto, setModalPhoto] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Fetch the latest photos from your API endpoint
    fetch(`${config.apiUrl}/photography`) // Replace with your actual API endpoint
      .then(response => response.json())
      .then(data => {
        setPhotos(data.slice(0, 8));
      }) // Assuming you want to show 8 recent photos
      .catch(error => console.error('Error fetching photos:', error));
  }, []);

  useEffect(() => {
    // Clean up modal state on unmount or when navigating away
    return () => {
      setIsModalOpen(false);
      setModalPhoto(null);
    };
  }, []);

  const openModal = (photo) => {
    setModalPhoto(photo);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalPhoto(null); // Reset modal photo
  };

  const showPhoto = (id) => {
    const photo = photos.find((p) => p.id === id);
    if (photo) {
      openModal(photo); // Only open the modal if a valid photo is found
    }
  };

  const modal = isModalOpen && modalPhoto && (
    <Modal
      modalPhoto={modalPhoto}
      openModal={isModalOpen}
      closeModal={closeModal}
      plusSlides={() => {}}
      hasPrev={false}
      hasNext={false}
    />
  );

  // Split photos into columns for display in the gallery
  const column1 = photos.slice(0, 2);
  const column2 = photos.slice(2, 4);
  const column3 = photos.slice(4, 6);
  const column4 = photos.slice(6, 8);

  return (
    <div className="wrapper-lighter">
      <div className="home-section">
        <h2 className="title-blue">Photography</h2>
        <ImageGallery 
          column1={column1} 
          column2={column2} 
          column3={column3} 
          column4={column4} 
          openModal={openModal} 
          showPhoto={showPhoto} 
        />
        <div className="center">
          <ButtonBlue destination={'/photography'} text={'View More Photography'} />
        </div>
      </div>
      {/* Render the modal using a React Portal */}
      {isModalOpen && ReactDOM.createPortal(modal, document.body)}
    </div>
  );
};

export default HomePagePhotography;